import { mainApi } from "services/main";
import {
  EvaluateClosingRequirementsRequest,
  EvaluateClosingRequirementsResponse,
  GetClosingRequirementsRequest,
  GetClosingRequirementsResponse,
  UpdateClosingRequirementsRequest,
  UpdateClosingRequirementsResponse,
} from "./definitions";

const extendedApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    getClosingRequirements: builder.query<
      GetClosingRequirementsResponse,
      GetClosingRequirementsRequest
    >({
      query: (request: GetClosingRequirementsRequest) => ({
        url: "closing-requirements",
        params: request,
      }),
      providesTags: ["ClosingRequirements"],
    }),
    updateClosingRequirements: builder.mutation<
      UpdateClosingRequirementsResponse,
      UpdateClosingRequirementsRequest
    >({
      query: ({
        teamName,
        gaiaObjectType,
        ...body
      }: UpdateClosingRequirementsRequest) => ({
        url: `closing-requirements/${teamName}/${gaiaObjectType}`,
        body,
        method: "PUT",
      }),
      invalidatesTags: ["ClosingRequirements"],
    }),
    evaluateClosingRequirements: builder.mutation<
      EvaluateClosingRequirementsResponse,
      EvaluateClosingRequirementsRequest
    >({
      query: ({ gaiaObjectId, ...body }) => ({
        url: `closing-requirements/evaluate/${gaiaObjectId}`,
        body,
        method: "POST",
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetClosingRequirementsQuery,
  useUpdateClosingRequirementsMutation,
  useEvaluateClosingRequirementsMutation,
} = extendedApi;
